import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Typography, Tooltip } from '@material-ui/core';
import { AddRounded, CheckRounded, CloseRounded, DeleteRounded, AddBoxRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size } from 'lodash';
import ClientPopUp from '../clients/ClientPopUp';
import DeleteDialogConfirm from '../../../../commonModules/interface/DeleteDialogConfirm';
import Currency from '../../../../commonModules/Currency';
import { toast } from 'react-toastify';

class ListCredit extends Component {
    state = { 
        breadcrumb: "",

        deletePopUp: false,
        toDeleteClient:"",
        toDelete:{
            id:"",
        },
       
        view: "list",
        clientPopUp: false,
        client:{}

    }
    componentDidMount = () => {
        console.log("MOUNTING ListCredits ");
    }
    
    createCreditList = (list) => {
        const { SHOPS, CLIENTS, SALES, rowsPerPage, currentPage } = this.props

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(credit => {
            if(credit){ // need to check after delete credit/prepa to prevent error
                const client = CLIENTS[credit.client_ref]
                let client_name = client ? `${client.client_firstname} ${client.client_lastname}` : ""
                const sale = SALES[credit.sale_id]
                const shop = SHOPS[credit.shop_id]
                // console.log({credit, shop, client});
                return (        
                    <TableRow key={credit.id}>
                        {/* <td>{credit.id}</td> */}
                        {/* <TableCell 
							padding="checkbox"
						>
                            {!!!sale.fact_id_5000 && sale.nature !== "payg" && !sale.sale_credit &&
                                <Checkbox
                                    onClick={event => this.handleClick(event, sale.id)}
                                    // disabled={!!sale.income_id}
                                    checked={isSelected(sale.id)}
                                    inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                                />
                            }
                            {!!sale.fact_id_5000 &&
							<Box p={1}>
								<IndeterminateCheckBoxOutlined
									onClick={() => this.setState({unlink: sale, openUnLink: true})}
									style={{color: red[100]}}
									// indeterminate
									// inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
								/>
							</Box>
							}
                        </TableCell> */}
                        <TableCell>{(new Date(credit.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            {shop ? (
                                <a href="#" onClick={
                                    () => this.props.handleSingleShop(shop) 
                                    }
                                > {shop.name} </a>
                            ) : (
                                <span>{credit.shop_name}</span>
                            )}
                        </TableCell>
                        <TableCell>
                            {client && 
                                <a href="#" onClick={
                                    () => this.setState({
                                        client,
                                        clientPopUp: true
                                    })
                                }>
                                    {client_name}
                                </a> 
                            }
                        </TableCell>
                        <TableCell><Currency value={credit.amount} /> </TableCell>
                        <TableCell>
                            <Currency value={
                                sale && Number(sale.total_price) > 0 && sale.total_price_TTC != null
                                    ? credit.amount * (Number(sale.total_price_TTC) / Number(sale.total_price))
                                    : credit.amount
                            } />
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={
                                () => this.props.handleSingleCredit(credit, shop, client,sale)
                            }>
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <Tooltip placement="top" title="Supprimer">
                                <IconButton 
                                    onClick={()=> this.setState({
                                        toDelete: credit,
                                        toDeleteClient: client_name,
                                        deletePopUp : true
                                    })
                                    }
                                >
                                    <CloseRounded color="error" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                )
            }
        })        
    }  
    
    displayList = () => {
        const { SALE_CREDITS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(SALE_CREDITS)){
            let filteredList = this.props.getFilteredList()
            rows = size(filteredList)
            tab = this.createCreditList(filteredList)
        }
        return [tab, rows]
    }  
        
    deleteCredit = async (comments) => {
        let data = {
            op_id: this.state.toDelete.id,
            comments
        }
        this.props.deleteCredit(data)
        // this.props.deleteCredit(this.state.toDelete)
        if(this.props.STATE.credits.error){
            console.log("[ERROR] delete credit", this.props.STATE.credits.error); 
            toast.error(  "Un Problème est survenu")
        } else {
            toast.success( "Paiement supprimée avec succès")
            this.setState({
                deletePopUp:false,
                toDelete:{id: ""},
            })
        }  
    }

    render() {
        const { view } = this.state;
        let creditList = this.displayList()

        console.log('====================================');
        console.log("[STATE] LIST SALE_CREDIT", this.state);
        console.log('====================================');

        return (
            <React.Fragment>
                {this.state.deletePopUp &&
                    <DeleteDialogConfirm
                        open={true}
                        close={()=>this.setState({deletePopUp: false})}
                        title={"le paiement pour "+ this.state.toDeleteClient}
                        handleSubmit={this.deleteCredit}
                        disabledSubmit={this.props.STATE.credits.fetching}
                    />
                }
                {this.state.clientPopUp && !isEmpty(this.state.client) &&
                    <ClientPopUp 
                        client={this.state.client}
                        {...this.props}
                        closePopUp={() => this.setState({clientPopUp:false, client:{}}) }
                    />
                }
                
                { view === "list" &&
                    <Box>
                        <Box p={1}>
                            <Typography variant="h6">Liste des paiements</Typography>
                        </Box>
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Nom Client</TableCell>
                                    <TableCell>Montant HT</TableCell>
                                    <TableCell>Montant TTC</TableCell>
                                    <TableCell>Échéancier</TableCell>
                                    <TableCell>Supprimer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { creditList[1] !== 0  && 
                                    creditList[0]
                                }
                                { creditList[1] === 0  && 
                                <TableRow>
                                    <TableCell colSpan={7}>
                                        <div className="text-center">
                                            <h5>Pas encore de Paiement</h5> 
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            { creditList[1] > 20  && 
                                <TableFooterPagination 
                                    colSpan={7}
                                    count={creditList[1]}
                                    onChangePage={this.props.onChangePage}
                                    initialPage={this.props.currentPage || 0}
                                    page={this.props.currentPage}
                                />         
                            }           
                        </ListLayout>
                    </Box>
                }
            </React.Fragment>
        );
    }
}


export default ListCredit;